import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const AtribuicoesExtra = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if (ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="ATRIBUIÇÕES EXTRA COMPETÊNCIA PROFISSIONAL" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Montagem e/ou Troca do Circuito do Ventilador Mecânico" nome="atribumec" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Coleta de Secreção Traqueal para Cultura" nome="atribucoleta" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Transporte de Pacientes Intra Hospitalar" nome="atributransp" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Decanulação e/ou Troca de Cânula Traqueal" nome="atribudeca" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />

                        <Select label="Troca dos Copos Coletores de Secreção Traqueal" nome="atributroca" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Aspiração Extra Atendiment/Procedimento Fisioterapêutico" nome="atribuasp" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Transporte de Pacientes Extra Hospitalar" nome="atributransporte" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Participação Durante o Procedimento da Traqueostomia" nome="atribuparti" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>

                </Caixa>
            )
        }
        return partes
    }
}

export default AtribuicoesExtra